import { syncInlineToolbarVisibility } from "./froalaSelectionUtils";

export { hasTextSelection, syncInlineToolbarVisibility } from "./froalaSelectionUtils";

export const froalaEditor = (function () {
  return {
    config: function () {
      return {
        key: "pe1G2wD1D1A2B1A5B5nDe1YRTYKd1Dd1f1JVVD1VJKKYLMPvC2B1F1G1B4D4E3B1C8E7==",
        toolbarInline: true,
        toolbarVisibleWithoutSelection: false,
        charCounterCount: false,
        toolbarButtons: [
          "bold",
          "italic",
          "underline",
          "strikeThrough",
          "subscript",
          "superscript",
          "outdent",
          "indent",
          "clearFormatting",
          "undo",
          "redo",
        ],
        height: "100%",
        events: {
          initialized: function () {
            const editor = this;
            editor.events.on("selection.change", function () {
              syncInlineToolbarVisibility(editor);
            });
          },
        },
      };
    },
  };
})();
